module.exports = __webpack_public_path__ + "img/lasource-33.8e9d57ef.jpg";